import React, { useState, useEffect, useRef } from 'react';
import Table from '../../Common/table';
import axios from '../../httpServices/httpService';
import api from '../../config.json'
import swal from 'sweetalert';
import auth from '../../httpServices/authService';
import validation from '../../utill/validation';
import _, { cloneDeep, result } from 'lodash';
import joi, { object } from 'joi'
import Loading from '../../utill/LoadingComponent';
import date from '../../utill/dateTime';
// import EquipmentSelection from '../Common/equipmentSelection';
import { ToastContainer, toast } from 'react-toastify';
import DateSelection from '../../Common/DateSelection';
import { Button, Modal, Select } from 'antd';
// import 'antd/dist/antd.css';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faFilePdf, faMinusCircle, faPlusCircle, faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import ExportPdfButton from '../../utill/ExportPdf';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import Tooltip from '../../utill/tooltip';
import PaginationComponent from '../../Common/PaginationComponent';
import { generateExcelFile } from '../../utill/download';


const ViewLogsReport = ({ handleDownloadTableToExcel, equips, equipGroups, fromDateLimit, Heading }) => {
    const reportType = [
        // { label: "Incoming Inspection", value: "Incoming", name: "IncomingInspection" },
        // { label: "First Part Inspection", value: "FirstPart", name: "FirstPartInspection" },
        // { label: "Inprocess Inspection", value: "Inprocess", name: "InProcessInspection" },
        // { label: "Last Part Inspection ", value: "LastPart", name: "LastPartInspection" },
        // { label: "FinishedGoods Inspection", value: "FinishedGoods", name: 'FG_Inspection' }
    ]
    const [qualityData, setQualityData] = useState([])
    const [inputData, setInputData] = useState({ From: new Date(), Till: new Date() })
    const [parts, setAllParts] = useState([]);
    const [types, setAllTypes] = useState([]);
    const [allTypeCache, setAllTypeCache] = useState([]);
    const [querySuccess, setQuerySuccess] = useState(false);
    const [sortColumn, setSortColumn] = useState({ path: 'ToolId', order: 'asc' })
    const [open, setOpen] = useState(false);
    const [pdfOpen, setPdfOpen] = useState(false);
    const [reportData, setReportData] = useState([]);
    const [checkPointTemplates, setCheckPointTemplates] = useState([]);
    const [company, setCompany] = useState({})
    const [loader, setLoader] = useState(false)
    const [methods, setMethods] = useState([])
    const [allPartsCache, setAllPartsCache] = useState([]);
    const [itemNumber, setAllItemNumber] = useState([]);
    const [operations, setAllOperations] = useState([]);
    const [selectedTemplates, setSelectedTemplate] = useState({ Columns: [] })
    const [pdfData, setPdfData] = useState([])
    const [CurrentPage, setCurrentPage] = useState(1);
    const [TotalPage, setTotalPage] = useState(0);
    const [PageSize, setPageSize] = useState(50);


    const customerRef = useRef(null);
    // const filteredOptions = clients.filter((o) => !selectedItems.find(b => o.label == b));

    useEffect(() => {
        Heading('Traceability Logs')
        GetAllInspetcionTypes();
        getAllPart();
        getCompanyDetail()
    }, [])
    useEffect(() => {
        handleGetData()
    }, [CurrentPage, PageSize]);

    const getCompanyDetail = () => {
        axios.get(api.api + 'company/' + auth.getCurrentUser().company)
            .then((result) => {
                setCompany(result.data)
            })
            .catch((err) => {
                console.error(err);
            });
    }

    const demoFromHTML = async () => {
        const source = customerRef.current;

        // Wait for all images in the source element to be loaded
        const loadImages = () => {
            const images = source.getElementsByTagName('img');
            const promises = Array.from(images).map((img) => {
                return new Promise((resolve) => {
                    if (img.complete) {
                        resolve();
                    } else {
                        img.onload = resolve;
                        img.onerror = resolve; // Resolve in case of an error as well
                    }
                });
            });
            return Promise.all(promises);
        };

        // Wait for images to load
        await loadImages();

        const table = source.querySelector('table'); // Target the table element
        const rows = Array.from(table.querySelectorAll('tr')); // Get all rows of the table

        const maxRowsPerPage = 25; // Set 25 rows per page
        const totalRows = rows.length;
        const numPages = Math.ceil(totalRows / maxRowsPerPage); // Calculate the number of pages needed

        const pdf = new jsPDF('landscape', 'pt', 'a4');
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const margin = 20;
        const marginWidth = margin;
        const marginHeight = margin;

        const availableWidth = pdfWidth - 2 * marginWidth;
        const availableHeight = pdfHeight - 2 * marginHeight;

        for (let page = 0; page < numPages; page++) {
            const canvas = await html2canvas(source, { scale: 2 });

            // Get only the rows for the current page (25 rows per page)
            const startRow = page * maxRowsPerPage;
            const endRow = Math.min((page + 1) * maxRowsPerPage, totalRows);
            const currentRows = rows.slice(startRow, endRow);

            // Temporarily hide rows not belonging to the current page
            rows.forEach((row, index) => {
                row.style.display = index >= startRow && index < endRow ? '' : 'none';
            });

            // Re-render the canvas for the current page's content
            const canvasForPage = await html2canvas(source, { scale: 2 });
            const imgData = canvasForPage.toDataURL('image/jpeg', 0.7);

            const imgHeight = (canvasForPage.height * availableWidth) / canvasForPage.width;
            const position = marginHeight;

            // Add content to the PDF for the current page
            pdf.addImage(
                imgData,
                'JPEG',
                marginWidth,
                position,
                availableWidth,
                imgHeight > availableHeight ? availableHeight : imgHeight
            );

            if (page < numPages - 1) {
                pdf.addPage(); // Add a new page if it's not the last one
            }
        }

        // Restore all rows to be visible after generating the PDF
        rows.forEach(row => (row.style.display = ''));

        pdf.save(`${reportData.InspectionType}_${new Date(reportData.DateTime).toLocaleString()}.pdf`);
    };







    const demoFromHTML1 = async () => {
        const source = customerRef.current;
        const canvas = await html2canvas(source);
        const imgData = canvas.toDataURL('image/png');

        const pdf = new jsPDF('p', 'pt', 'letter');
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        const margin = 0.02; // 2% margin
        const marginWidth = pdfWidth * margin;
        const marginHeight = pdfHeight * margin;

        const availableWidth = pdfWidth - 2 * marginWidth;
        const availableHeight = (imgProps.height * availableWidth) / imgProps.width;

        pdf.addImage(
            imgData,
            'PNG',
            marginWidth,
            marginHeight,
            availableWidth,
            availableHeight > pdfHeight - 2 * marginHeight ? pdfHeight - 2 * marginHeight : availableHeight
        );

        pdf.save('Test.pdf');
    };



    const handleOnChange = (name, value) => {
        const obj = { ...inputData }
        obj[name] = value;
        setInputData(obj);
        console.log(obj);
        // if (name == "Code") {
        //     console.log(allPartsCache,"wdiuffn")
        //     const numbers = allPartsCache
        //     .filter(one => one.CompoundCode || value.includes("All"))
        //     .map(one => ({ label: one.BatchCode, value: one.BatchCode }));
          
        //   setAllParts(numbers);

        // }
      
     
    }


    const getAllPart = () => {
        axios.get(api.api + "compoundCode")
            .then((result) => {
                console.log(result.data,"batches")
                setAllPartsCache(result.data)

                const all = result.data.map((one) => { return { label: one.ItemName, value: one.ItemName } })

               // setAllParts(all)
            })
            .catch((err) => {
                console.log(err, "Error")
            })
    }




    const handleGetData = async () => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'Logs', { query: inputData, PageSize: PageSize, Page: CurrentPage })
            .then((result) => {
                setLoader(false)
                console.log(result.data.result,"jjkfhshf",inputData)
                setQualityData(result.data.result);
                setTotalPage(result.data.totalDocument);
                console.log(result.data, "-----------------");
            })
            
            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }
    const handleGetData1 = async (data,inputData) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'Logs', {Search:inputData, query: 'Search', PageSize: PageSize, Page: CurrentPage })
            .then((result) => {
                setLoader(false)
                console.log(result,"jjkfhshf",inputData)
                setTotalPage(result.data.totalDocument);
                setQualityData(result.data.result);

                console.log(result.data, "-----------------");
            })
            
            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }
    async function getBase64FromImageUrl(url) {
        try {
            // Fetch the image data from the URL
            const response = await fetch(url);
            const blob = await response.blob();

            // Create a FileReader to convert the Blob to base64
            const reader = new FileReader();

            return new Promise((resolve, reject) => {
                reader.onloadend = function () {
                    // Extract base64 string from the data URL
                    const base64String = reader.result.split(',')[1];
                    resolve(base64String);
                };

                reader.onerror = function (error) {
                    reject(error);
                };

                // Read the Blob as a data URL
                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.error('Error fetching or converting image:', error);
            throw error;
        }
    }



    const handleGetPdfData = async (query) => {
        // inputData.Clients = selectedItems.includes("All") ? clients : clients.filter(one => selectedItems.includes(one.label));
        setLoader(true)
        axios.put(api.api + 'ViewReport', query)
            .then((result) => {
                setPdfData(result.data);
                setLoader(false)
            })
            .catch((err) => {
                setLoader(false)
                console.log(err);
            })
    }




    const handleInputChange = (parentIdx, index, e) => {
        const data = { ...qualityData };
        data[parentIdx].Standard[index][e.currentTarget.name] = e.currentTarget.value;

        setQualityData(qualityData)
    }
    const handleSort = sortColumn => {
        if (qualityData.length > 0) {
          const sorted = _.orderBy(qualityData, [sortColumn.path], [sortColumn.order]);
          setSortColumn(sortColumn)
          setQualityData(sorted)
        }
      }
    const handleOnSubmit = () => {
        const data = [...qualityData];
        const obj = { PartID: inputData.PartID, compoundMaster: inputData.InspectionType, DateTime: inputData.DateTime, Reports: [] }
        data.forEach((sample, index) => {
            const reports = { SampleSerial: index + 1, InspectionData: [] }
            sample.Standard.forEach((one, index) => {
                reports.InspectionData.push({ Parameter: one.Parameter, ObservedValue: one.ObservedValue, Result: one.Result, Remarks: one.Remarks, StandardType: one.StandardType })
            })
            obj.Reports.push(reports);
        })
        axios.post(api.api + "inspectionReport", obj)
            .then((result) => {
                setQualityData([])
                swal("Data Saved Successfully")
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const addMore = () => {
        const data = cloneDeep(qualityData);
        const obj = cloneDeep(data[data.length - 1])
        obj.Standard.forEach((one) => {
            delete one.ObservedValue
            delete one.Result
            delete one.Remarks
        })
        setQualityData([...data, obj]);
    }

    const removeRow = () => {
        let data = [...qualityData];
        data.splice(data.length - 1, 1)
        setQualityData(data);
    }



    const getStandardType = (obj) => {
        if (obj && obj.StandardType == "Dimension") {
            return `(Dimension (+${obj.PlusTolerance}/-${obj.MinusTolerance}))`
        }
        return `(Description)`
    }

    const extractInspectionDataSeparateArray = (data) => {

        const separateInspectionDataArray = [];

        // Iterate through each report
        if (data) {
            console.log(data, "testingthe data")
            data && data.Reports && data.Reports.forEach((report) => {
                // Iterate through InspectionData in the report
                report.InspectionData.forEach((inspection) => {
                    const parameter = inspection.Parameter;
                    const existingEntry = separateInspectionDataArray.find(entry => entry.Parameter === parameter);

                    if (existingEntry) {
                        existingEntry.InspectionData.push(inspection);
                    } else {
                        separateInspectionDataArray.push({
                            Parameter: parameter,
                            InspectionData: [inspection]
                        });
                    }
                });
            });
        }

        data.InspectionData = separateInspectionDataArray
        console.log(data, "data for the table")
        return [data];
    };

    const getRange = (one) => {
        let str = '-'
        if (one.StandardType == "Dimension") {
            const dim = parseFloat(one.Dimension)
            const plus = dim + parseFloat(one.PlusTolerance)
            const minus = dim - parseFloat(one.MinusTolerance)
            str = `( ${plus} - ${minus} ) ${one.UOM}`
        }

        return str
    }

    const getItem = () => {
        const item = allPartsCache.find(part => part.ItemName == reportData.BatchCode && part.ItemNumber == reportData.ItemNumber );
        if (item) {
            return item
        }
        return {}
    }


    const reportTypes = ["Retrospective Inspection",
        "Setup Approval Inspection",
        "Process/Product Patrol Inspection",
        "Poka - Yoke Sheet",
        "IFM - Product - Msr",
        "IFM - Process - Fbd",
        "IFM_Product_FBD","Quality Assurance Plan For Straightening and lacquering"
        
    ]
    const columns1 = [
        { path: "DateTime", label: "Date", content: (obj) => (<>{moment(obj.DateTime).format('DD-MM-YY')}</>) },       
        { path: "DateTime", label: "Time", content: (obj) => (<>{moment(obj.DateTime).format('hh:mm a')}</>) },       
        { path: "ToolId", label: "Tool ID" },
        { path: "BatchCode", label: "Batch Number" },
        { path: "TracebilityNo", label: "Tracebility Number" },
        { path: "Qty", label: "Qty (kg)" },

        

        
        { path: "Result", label: "Result", content:(obj) => (<div style={{color:'white',width:'100%',backgroundColor:`${obj.Result=='OK'?'green':'red'}`}}>{obj.Result}</div>)},
        
        // {
        //     key: "view",
        //     label: "View Report",
        //     content: (obj) => (
        //         <React.Fragment>
        //             <button className='btn btn-secondary' onClick={() => {
        //                 const part = allPartsCache.find((part) => part.ItemName == obj.BatchCode && part.ItemNumber == obj.ItemNumber )
        //                 if (part) {
        //                     const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
        //                     const template = checkPointTemplates.find(x => checkSheet && checkSheet.checkSheetTitle && x.Name == checkSheet.checkSheetTitle.TemplateName)
        //                     template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
        //                     setSelectedTemplate(template)
        //                 }
        //                 setReportData(obj);
        //                 setOpen(true)
        //             }}>
        //                 <FontAwesomeIcon icon={faFile} />
        //             </button>
        //         </React.Fragment>
        //     ),
        // },
        // {
        //     key: "PDF View",
        //     label: "View PDF",
        //     content: (obj) => (
        //         <React.Fragment>
        //             {
        //                 reportTypes.filter(item => item == obj.InspectionType).length > 0 ? <button className='btn btn-secondary' onClick={() => {
        //                     const part = allPartsCache.find((part) => part.ItemName == obj.BatchCode && part.ItemNumber == obj.ItemNumber )
        //                     if (part) {
        //                         const checkSheet = part.Inspection.find(x => x.InspectionName == obj.InspectionType)
        //                         const template = checkPointTemplates.find(x => checkSheet.checkSheetTitle && x.Name == checkSheet.checkSheetTitle.TemplateName)
        //                         template.Columns = template.Columns.filter(x => x.EnableForDataEntry)
        //                         setSelectedTemplate(template)
        //                         const shift = obj.customFields.find(x => x && x.FieldName == "Shift")
        //                         const batchCode = obj.customFields.find(x => x && x.FieldName == "Batch Code")
        //                         const machine = obj.customFields.find(x => x && x.FieldName == "Machine")
        //                         if (obj.InspectionType == "Poka - Yoke Sheet") {
        //                             const currentDate = new Date();
        //                             const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        //                             handleGetPdfData({ InspectionType: obj.InspectionType, ItemName: obj.BatchCode, ItemNumber: obj.ItemNumber,
        //                                 //  Operation: obj.Operation,
        //                                   From: startOfMonth, Till: currentDate, Shift: shift ? shift.Value : "" })
        //                         } else {
        //                             handleGetPdfData({ InspectionType: obj.InspectionType, ItemName: obj.BatchCode, ItemNumber: obj.ItemNumber,
        //                                 //  Operation: obj.Operation,
        //                                   From: obj.DateTime, Till: obj.DateTime, Machine: machine, BatchCode: batchCode, Shift: shift ? shift.Value : "" })
        //                         }
        //                     }
        //                     setReportData(obj);
        //                     setPdfOpen(true)
        //                 }}>
        //                     <FontAwesomeIcon icon={faFilePdf} />
        //                 </button>
        //                     : <Tooltip text="Report Unavailable">
        //                         <button className='btn btn-secondary' disabled={true}>
        //                             <FontAwesomeIcon icon={faFilePdf} />

        //                         </button>
        //                     </Tooltip>}


        //         </React.Fragment>
        //     ),
        // },
    ];

    const GetAllInspetcionTypes = () => {
        axios.get(api.api + 'compoundMaster')
            .then((result) => {
                const reports = [...reportType]
                result.data.forEach((one) => {
                    const obj = { label: one.CompoundCode, value: one.CompoundCode, name: one.CompoundCode }
                    reports.push(obj)
                })
                setAllTypeCache(result.data)
                setAllTypes(reports)
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleDownloadExcel = (e) => {
        generateExcelFile(e);
      };


    return (
        <React.Fragment>
            {loader ? <Loading labelShow={true} label={"Loading..."} /> : ''}
            {/* <div className='text-center' >
                <p >QMS Report</p>
            </div> */}

            {/* <ToastContainer /> */}

            <div className="row">
                <div className="col-sm-2">
                    <div className="form-group">
                        <label className='small m-0'>From</label>
                        <input value={moment(inputData.From).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('From', e.currentTarget.value)} type='date' />

                    </div>
                </div>
                <div className="col-sm-2">
                    <div className="form-group">
                        <label className='small m-0'>Till</label>
                        <input value={moment(inputData.Till).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('Till', e.currentTarget.value)} type='date' />

                    </div>
                </div>
                <div className='col-sm-2'>
                    <label className='small text-center m-0'>Compound Code</label>
                    <Select
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Compound Code"
                        value={inputData.Code}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.Code && (inputData.Code.length === types.length)) {
                                    handleOnChange('Code', []);
                                } else {
                                    handleOnChange('Code', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('Code', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={[
                            { label: 'All', value: 'All' },
                            ...types
                        ]}
                    />

                </div>
                <div className='col-sm-2'>
                    {/* <label className='small text-center m-0'>Batch Number</label>
                    <Select
                        maxTagCount={"responsive"}
                        mode="multiple"
                        placeholder="Select Batch Number"
                        value={inputData.BatchCode}
                        onChange={(values) => {
                            if (values.includes('All')) {
                                if (inputData.BatchCode && (inputData.BatchCode.length === parts.length)) {
                                    // Deselect all if "Select All" was deselected
                                    handleOnChange('BatchCode', []);
                                } else {
                                    // Select all
                                    handleOnChange('BatchCode', ["All"]);
                                }
                            } else {
                                // Update selected values normally
                                handleOnChange('BatchCode', values);
                            }
                        }}
                        style={{ width: '100%' }}
                        options={parts.length == 0 ? [] : [
                            { label: 'All', value: 'All' },
                            ..._.uniqBy(parts, "value")
                        ]}
                    /> */}
                     <div className="form-group form-group-sm d-flex flex-column">
                <label htmlFor="operationRejectionCost " className="small m-0 ">
                 
                  Batch Code
                </label>
                <input
                  required
                  onChange={(e)=>handleOnChange('BatchCode',e.currentTarget.value)}
                  //disabled={cycleTimeRadioState === 1 ? false : true}
                  className="form-control form-control-sm w-100 m-0 "
                  style={{backgroundColor:'white'}}
                  type="text"
                  name={'BatchCode'}
                  value={inputData.BatchCode ||''}
                  placeholder={'Enter BatchCode '}

                />
                {/* {errors.BatchCode && (
                  <div className="alert small alert-danger">
                    {errors['BatchCode']}
                  </div>
                )} */}
              </div>
                </div>
              

                <div className="col-sm-1">
                    <button className='btn btn-primary btn-sm mt-4' onClick={() => handleGetData()}>Apply</button>
                </div>
                <Modal
                    // title={<strong>Report    <button className="btn-sm btn-primary" onClick={demoFromHTML}>Download PDF</button></strong>}
                    centered
                    open={open}
                    // onOk={() => setOpen(false)}
                    onCancel={() => setOpen(false)}
                    footer={[]}
                    width={"95%"}
                >
                    
                </Modal>
            </div>


            <Modal
                title=''
                centered
                open={pdfOpen}
                // onOk={() => setPdfOpen(false)}
                onCancel={() => setPdfOpen(false)}
                width={"95%"}
                footer={[]}
            >
                {/* <button className="btn-sm btn-primary" onClick={demoFromHTML}>Download PDF</button> */}
                <div id="customers" ref={customerRef} className='p-1  w-100'>
                    {/* {reports[reportData.InspectionType]} */}
                    {/* <ProcessProductPatrolInspection item={allPartsCache.find(x => x.ItemName == inputData.ItemName)} company={company} data={reportData} pdfData={pdfData} /> */}
                </div>
            </Modal>

            {qualityData && qualityData.length > 0 ?  <div className="col-sm-2 py-4">
            <button   onClick={() => handleDownloadExcel("traceabilitylogsReport")}className="btn-sm btn-primary ">Download Report</button>
        </div>:''}

            {qualityData.length > 0 ? <Table
                id="traceabilitylogsReport"
                onSort={handleSort}
                columns={columns1}
                sortColumn={sortColumn}
                // data={extractInspectionDataSeparateArray(qualityData[0])}
                searchquery={true} handelSearch={handleGetData1}
                data={qualityData}
            />: <Table
            id="RejectionDetailedAnalysispiechart"
            onSort={handleSort}
            columns={columns1}
            sortColumn={sortColumn}
            // data={extractInspectionDataSeparateArray(qualityData[0])}
            searchquery={true} handelSearch={handleGetData1}
            data={[]}
        />}
            {qualityData.length > 0 && <div className="float-end m-3">
                <PaginationComponent  defaultCurrent={CurrentPage} total={TotalPage} CurrentPageNumber={(currentpage, pagesize) => { setCurrentPage(currentpage); setPageSize(pagesize) }} />
            </div>}
        </React.Fragment>
    );
}
export default ViewLogsReport;